import script from "./EditorField.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorField.vue?vue&type=script&setup=true&lang=js"

import "./EditorField.vue?vue&type=style&index=0&id=288a6fcc&scoped=true&lang=css"

import exportComponent from "/home/datakepler/public_html/deploy-cache/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-288a6fcc"]])

export default __exports__